import * as React from 'react';
import * as main from "../../main.module.scss";
import * as plan from "./style.module.scss";
export const Plan = () => {
  return (
    <section className={plan.plan}>
      <div className="container">
        <div className={plan.container}>
          <h2>План вебинара:</h2>
          <ul>
            <li>Откуда у гаджетов такая большая притягательность?</li>
            <li>Как гаджеты влияют на синтез гормонов радости и гормонов стресса, а через них создают зависимость?</li>
            <li>Можно ли бороться с зависимостью от гаджетов и как?</li>
            <li>Насколько эффективно отбирать гаджеты и можно ли их не давать?</li>
            <li>Поэтапный план вывода ребенка из гаджета.</li>
            <li>Понимание того, что ребенок «там» делает.</li>
            <li>Понимание видов ценности, которые ребенок получает в гаджетах и как мы можем дать их без гаджета.</li>
            <li>Привычки и ритуалы, снижающие гаджет зависимость.</li>
            <li>Особенности работы мозга детей подросткового возраста, повышенное влияние мнения окружающих, сепарация от родителей и отсутствие критического мышления.</li>
          </ul>
          <a className={main.btn} href={"#reg"}>Зарегистрироваться</a>
        </div>
      </div>
    </section>
  );
};
